import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const EliminarBoletin = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [boletin, setBoletin] = useState(null);
  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${API}/api/boletines/ver`)
      .then((res) => res.json())
      .then((data) => {
        const b = data.find((b) => b.Id.toString() === id);
        setBoletin(b);
      })
      .catch((err) => {
        console.error("❌ Error al obtener el boletín:", err);
        Swal.fire("❌ Error", "No se pudo cargar la información del boletín.", "error");
      });
  }, [id, API]);

  const handleDelete = async () => {
    const confirm = await Swal.fire({
      title: "¿Eliminar boletín?",
      text: `¿Estás seguro de eliminar "${boletin.Titulo}"? Esta acción no se puede deshacer.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (!confirm.isConfirmed) return;

    Swal.fire({
      title: "Eliminando...",
      text: "Espere un momento",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const res = await fetch(`${API}/api/boletines/eliminar/${id}`, {
        method: "DELETE",
      });

      if (!res.ok) throw new Error("No se pudo eliminar el boletín.");

      Swal.close();
      Swal.fire("✅ Eliminado", "El boletín fue eliminado correctamente.", "success");
      navigate(-1);
    } catch (error) {
      Swal.close();
      Swal.fire("❌ Error", error.message, "error");
    }
  };

  if (!boletin) return <p className="text-center mt-10">Cargando boletín...</p>;

  return (
    <div className="max-w-xl mx-auto mt-10 p-6 bg-white rounded shadow text-center">
      <h2 className="text-xl font-bold text-red-600 mb-4">Eliminar Boletín</h2>
      <p className="mb-4">
        ¿Seguro que deseas eliminar <strong>{boletin.Titulo}</strong>?
      </p>
      <button
        onClick={handleDelete}
        className="bg-red-700 text-white px-4 py-2 rounded hover:bg-red-800 mr-4"
      >
        Eliminar
      </button>
      <button
        onClick={() => navigate(-1)}
        className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
      >
        Cancelar
      </button>
    </div>
  );
};

export default EliminarBoletin;
